import request from '@/utils/request'

/**
 * Geodesia Acknowledgment API (اقرار الجيوديسيا)
 * Shares the existing survey chat — do not call separate chat endpoints.
 * Base: /projects/{projectId}/geodesia-acknowledgment
 *
 * Sequential chain: surveyor-acknowledgment → giser-acknowledgment → geodesia-acknowledgment
 * Recipients: gisser مكتب فني | Giser 168 (GIS office). Do not use جيوديسيا (GIS-ack recipients).
 *
 * Query keys (for cache invalidation after save/send):
 *   ['projects', projectId, 'geodesia-acknowledgment']
 *   ['projects', projectId, 'geodesia-acknowledgment', 'recipients']
 * Also invalidate GIS / surveyor / survey-chat queries that include geodesia_acknowledgment.
 *
 * @typedef {Object} GeodesiaAcknowledgment
 * @property {number} project_id
 * @property {string} acknowledgment_text
 * @property {boolean} acknowledged
 * @property {number|null} acknowledged_by
 * @property {string|null} acknowledged_at
 * @property {'draft'|'sent'} status
 * @property {number|null} sent_by
 * @property {string|null} sent_at
 * @property {boolean} is_sent
 * @property {Object} [acknowledged_by_user]
 * @property {Object} [sent_by_user]
 * @property {Object} [chat]
 */

const base = projectId => `/projects/${projectId}/geodesia-acknowledgment`

/** GET /geodesia-acknowledgment — includes can_acknowledge + giser_acknowledgment + surveyor_acknowledgment + same survey chat */
export const getGeodesiaAcknowledgment = projectId => request({
  url: base(projectId),
  method: 'get',
})

/** POST /geodesia-acknowledgment/save — body: { acknowledged: true } */
export const saveGeodesiaAcknowledgment = (projectId, data) => request({
  url: `${base(projectId)}/save`,
  method: 'post',
  data,
})

/** GET /geodesia-acknowledgment/recipients?keyword= — users with roles gisser مكتب فني | Giser 168 */
export const getGeodesiaAcknowledgmentRecipients = (projectId, params = {}) => request({
  url: `${base(projectId)}/recipients`,
  method: 'get',
  params,
})

/** POST /geodesia-acknowledgment/save-and-send — body: { acknowledged: true, recipient_user_ids: [] } */
export const saveAndSendGeodesiaAcknowledgment = (projectId, data) => request({
  url: `${base(projectId)}/save-and-send`,
  method: 'post',
  data,
})
